var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar45(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53523 0.342499C4.6868 -0.114165 5.33275 -0.114165 5.48432 0.342499L6.33049 2.89197C6.39836 3.09645 6.58958 3.23446 6.80504 3.23446H9.52032C10.0073 3.23446 10.2069 3.85969 9.81012 4.14191L7.63183 5.69125C7.45285 5.81855 7.3779 6.04775 7.44708 6.2562L8.28341 8.77602C8.43569 9.23481 7.91299 9.62115 7.51907 9.34097L5.29958 7.76233C5.12608 7.63893 4.89347 7.63893 4.71997 7.76233L2.50048 9.34097C2.10656 9.62115 1.58386 9.23481 1.73614 8.77602L2.57247 6.2562C2.64165 6.04775 2.5667 5.81855 2.38772 5.69125L0.209426 4.14191C-0.187374 3.85968 0.0122966 3.23446 0.499229 3.23446H3.21451C3.42997 3.23446 3.62119 3.09645 3.68906 2.89197L4.53523 0.342499Z",
    fill: "#FCC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar45);
export default __webpack_public_path__ + "static/media/star-4-5.bf1736292188a667b881fc0a6bb0ee3d.svg";
export { ForwardRef as ReactComponent };